import { render, staticRenderFns } from "./HubHero.vue?vue&type=template&id=5a3e168e&scoped=true"
import script from "./HubHero.vue?vue&type=script&lang=js"
export * from "./HubHero.vue?vue&type=script&lang=js"
import style0 from "./HubHero.vue?vue&type=style&index=0&id=5a3e168e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e168e",
  null
  
)

export default component.exports